// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2-NTY","field":"styles_field__2XUWH","fieldCol":"styles_fieldCol__3Zn1T","diffCol":"styles_diffCol__SgXlS","diff":"styles_diff__mvTXi"};